module.exports = __webpack_public_path__ + "static/media/gant2.7913f08b.webp";